import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ActiveFilter, ColumnWidth, GridConfiguration } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';

@Component({
  selector: 'app-view-masterdata',
  templateUrl: './view-masterdata.component.html',
  styleUrls: ['./view-masterdata.component.scss']
})
export class ViewMasterdataComponent {
  oDataUrl: string = 'getNormGrades';
  selected: string = 'normgrades';
  gridConfiguration: GridConfiguration = new GridConfiguration();
  oDataEntity: string = "VNormGrade";
  columnsToHide: string[] = ["normGradeId"];
  gridFilterable: boolean = false;
  buttonsList: TTButton[] = new Array();
  clearFilters: boolean = false;
  refreshGridKey: number = 0;
  filtersToHide: string[] = new Array();
  showOdataGrid: boolean = false;
  isDataFiltered: boolean = false;
  subscriptions: Subscription = new Subscription();
  columnsWidth: ColumnWidth[] = new Array();
  roundDigits: RoundDigit[] = [
    {
      section: 'Masterdata',
      fieldName: 'WeightPerLengthCoefficient',
      metricDigits: 10,
      imperialDigits: 10
    }
  ];

  constructor(public globals: Globals, private teiasoftLoader: TeiasoftLoaderService, private utils: UtilsService, private backendService: BackendService) {
    this.buildButtonsList();
    this.checkUserConfiguration();
    this.setColumnsWidth();
    this.showGrid();
  }

  /**
   * CHECK USER GRID CONFIGURATION
   */
  checkUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === this.oDataUrl);
    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    }
  }

  /**
 * TOOLBAR
 */
  buildButtonsList() {
    this.buttonsList = new Array();
    /* ALL */
    let _item: TTButton = new TTButton();
    /* SHOW/HIDE FILTER */
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = "";
    _item.state = this.isDataFiltered ? 'pressed' : '';;
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);
  }

  /**
   * REFRESH GRID
   */
  refreshFullGrid() {
    this.refreshGridKey++;
  }

  /**
   * SMALL DELAY IN SHOW GRID
   */
  showGrid() {
    setTimeout(() => this.showOdataGrid = true, 350);
  }

  /**
   * UPDATE USER CONFIGURATION
   */
  updateUserConfiguration() {
    this.subscriptions.add(this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      // MQF-263: sync also localstorage 
      /*       localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
            this.checkUserConfiguration(); */
    }));
  }

  /**
   * SET COLUMNS WIDTH
   */
  setColumnsWidth() {
    if (this.oDataUrl == 'getNormGrades') {
      this.columnsWidth = new Array();
      let _col: ColumnWidth = new ColumnWidth();
      _col.colName = "NormGradeCode";
      _col.length = 100;
      _col.width = 100;
      this.columnsWidth.push(_col);
    }

    if (this.oDataUrl == 'getRawMaterialGrades') {
      this.columnsWidth = new Array();
      let _col: ColumnWidth = new ColumnWidth();
      _col.colName = "RawMaterialGradeCode";
      _col.length = 50;
      _col.width = 50;
      this.columnsWidth.push(_col);

      _col = new ColumnWidth();
      _col.colName = "WeightPerLengthCoefficient";
      _col.length = 50;
      _col.width = 50;
      this.columnsWidth.push(_col);
    }

    if (this.oDataUrl == 'getCustomersWithBonusAgreement') {
      this.columnsWidth = new Array();
      let _col: ColumnWidth = new ColumnWidth();
      _col.colName = "CustomerName";
      _col.length = 100;
      _col.width = 100;
      this.columnsWidth.push(_col);
    }

    if (this.oDataUrl == 'getSms') {
      this.columnsWidth = new Array();
      let _col: ColumnWidth = new ColumnWidth();
      _col.colName = "Sms";
      _col.length = 100;
      _col.width = 100;
      this.columnsWidth.push(_col);
    }
  }

  /* EVENTS */
  onSelectThis(evt: string) {
    this.showOdataGrid = false;
    this.isDataFiltered = false;
    this.gridFilterable = false;
    this.clearFilters = true;
    setTimeout(() => { this.clearFilters = false }, 250);
    //this.refreshFullGrid();
    this.buildButtonsList();
    this.selected = evt;

    if (evt == 'normgrades') {
      this.columnsToHide = new Array();
      this.columnsToHide = ["normGradeId"];
      this.oDataUrl = 'getNormGrades';
      this.oDataEntity = 'VNormGrade';
      this.filtersToHide = new Array();
    }
    if (evt == 'raw') {
      this.columnsToHide = new Array();
      this.columnsToHide = ["empty"];
      this.oDataUrl = 'getRawMaterialGrades';
      this.oDataEntity = 'VRawMaterialGrade';
      this.filtersToHide = new Array();
      this.filtersToHide.push("WeightPerLengthCoefficient");
    }

    if (evt == 'customers') {
      this.columnsToHide = new Array();
      this.columnsToHide = ["empty"];
      this.oDataUrl = 'getCustomersWithBonusAgreement';
      this.oDataEntity = 'VCustomerWithBonusAgreement';
      this.filtersToHide = new Array();
      this.filtersToHide.push("Amount");
    }

    if (evt == 'sms') {
      this.columnsToHide = new Array();
      this.columnsToHide = ["empty"];
      this.oDataUrl = 'getSms';
      this.oDataEntity = 'VSms';
      this.filtersToHide = new Array();
    }

    this.checkUserConfiguration(); // MP: this is firing odata api call
    this.setColumnsWidth();
    // this.refreshFullGrid(); // MP: also this is firing odata api call
    this.showGrid();
  }

  onBtnToolbarClick(btn: TTButton) {
    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }

  }

  onActiveFiltersUpdate(activeFilters: ActiveFilter[]) {
    this.isDataFiltered = activeFilters.length > 0;
    this.buildButtonsList();
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.gridConfiguration = { ...gridConfiguration }; // sync current gridConfiguration

    this.updateUserConfiguration();
  }
}
